import { Styles } from 'assets/types';

const formFeesCardStyle: Styles = theme => ({
  buttonText: {
    whiteSpace: 'nowrap',
  },
});

export default formFeesCardStyle;
